import type { WhiteLabel } from '@skytech/types'

export const USER_TYPE = [
  { symbol: 'F' as const, name: 'Free' },
  { symbol: 'W' as const, name: 'Work' },
  { symbol: 'N' as const, name: 'None' },
  { symbol: 'A' as const, name: 'All' },
]

type UserGuideWhiteLabel = Extract<WhiteLabel, 'threeStepIT' | 'telia'> | 'default'
export const GUIDE_FILE_PATHS: Record<UserGuideWhiteLabel, string> = {
  threeStepIT: 'User_guide_Manager_portal_3stepIT.pdf',
  telia: '/Telia_Manager_Brukerveiledning_v1_7.pdf',
  default: '/User_guide_Manager_portal_v1_6.pdf',
}
